import { useTranslation } from '@mint-lib/i18n';
import { ArrowLeft } from '@mint-lib/icons';
import { TruncateText, typographyVariants } from '@mint-lib/tw-components';
import { Link as RouterLink } from '@mint/routing';

import { useDataFileContext } from '../../contexts/DataFileContext/useDataFileContext.js';
import { useImportHubPaths } from '../../hooks/useImportHubRouteApi.js';

export const Navbar = () => {
  const { t } = useTranslation('@myn/import-hub');
  const paths = useImportHubPaths();

  const { dataFilePreview, setActionsContainerElement } = useDataFileContext();

  const templateName = dataFilePreview.fromTemplate?.name;

  return (
    <div className="mb-3 flex items-center justify-between">
      <div className="min-w-0 shrink">
        <RouterLink
          to={paths.performance}
          className={typographyVariants({
            variant: 'bodyShort02',
            className:
              'mb-3 flex items-center gap-2 fill-text-link text-text-link',
          })}
          data-dd-action-name={'Back to Performance data import'}
        >
          <ArrowLeft />
          {t('Back to Performance data import')}
        </RouterLink>

        <TruncateText>
          <h2 className={typographyVariants({ variant: 'h2' })}>
            {templateName || t('New file')}
          </h2>
        </TruncateText>
      </div>
      <div
        ref={setActionsContainerElement}
        className="flex items-center gap-2"
      />
    </div>
  );
};
